import { render, staticRenderFns } from "./GftInfiniteAutoplay.vue?vue&type=template&id=58308d2b"
import script from "./GftInfiniteAutoplay.vue?vue&type=script&lang=ts"
export * from "./GftInfiniteAutoplay.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports